import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCopy, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { sherMyFiles } from '../../../../../services/CommonService';

const ShareDocumentModal = ({ show, onHide, selectedFiles, userId }) => {
  const [shareLink, setShareLink] = useState('');
  const [isShareLinkGenerated, setIsShareLinkGenerated] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGenerateShareLink = async () => {
    setLoading(true);
    try {
      const payload = {
        user_id: userId,
        file_ids: selectedFiles.map(file => file.id),
        is_view_only: false
      };

      const response = await sherMyFiles(payload);

      if (response.data && response.data.shareableLink) {
        setShareLink(response.data.shareableLink);
        setIsShareLinkGenerated(true);
        toast.success('Share link generated successfully!');
      } else {
        throw new Error('Failed to generate share link');
      }
    } catch (error) {
      console.error('Share link generation error:', error);
      toast.error(error.response?.data?.message || 'Failed to generate share link.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink)
      .then(() => {
        toast.success('Share link copied to clipboard!');
      })
      .catch(() => {
        toast.error('Failed to copy share link.');
      });
  };

  const handleWhatsAppShare = () => {
    const textToShare = `Check out these files I found on my Envelope portal: ${selectedFiles.map(f => f.file_name).join(', ')}. ${shareLink}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(textToShare)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailShare = () => {
    const textToShare = `Check out these files I found on my Envelope portal: ${selectedFiles.map(f => f.file_name).join(', ')}. ${shareLink}`;
    const emailSubject = `Envelope Files for you`;
    const emailBody = `I found some interesting files on my Envelope portal. Check them out!\n\n${textToShare}`;
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    window.open(mailtoUrl, '_blank');
  };

  const handleClose = () => {
    setShareLink('');
    setIsShareLinkGenerated(false);
    onHide();
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Share Files</Modal.Title>
          <button
            type="button"
            className="bg-transparent fw-bold"
            onClick={handleClose}
            disabled={loading}
            aria-label="Close"
          >
            <i className="bi bi-x-lg me-2"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          {!isShareLinkGenerated ? (
            <>
              <p>Selected Files: {selectedFiles.length}</p>
            </>
          ) : (
            <>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  value={shareLink}
                  readOnly
                  className="form-control mb-3 flex-grow-1 px-3 py-2 border border-secondary rounded"
                  style={{ fontSize: '16px' }}
                />
                <button
                  className="btn btn-outline-secondary mb-3 d-flex align-items-center justify-content-center"
                  style={{ padding: '12px', borderRadius: '5px' }}
                  onClick={handleCopyLink}
                >
                  <FaCopy size={18} />
                </button>
              </div>
              <div className="d-flex gap-2 mt-3">
                <button
                  className="btn btn-success d-flex align-items-center justify-content-center p-2 rounded-circle"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleWhatsAppShare}
                >
                  <FaWhatsapp size={20} className="text-white" />
                </button>
                <button
                  className="btn btn-danger d-flex align-items-center justify-content-center p-2 rounded-circle"
                  style={{ width: '40px', height: '40px' }}
                  onClick={handleEmailShare}
                >
                  <FaEnvelope size={20} className="text-white" />
                </button>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {!isShareLinkGenerated && (
            <Button
              variant="primary"
              onClick={handleGenerateShareLink}
              disabled={loading}
            >
              {loading ? 'Generating Share Link...' : 'Generate Share Link'}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShareDocumentModal; 